import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
// eslint-disable-next-line @nrwl/nx/enforce-module-boundaries
import { BaseCRUDApiClient } from '@ideapa/app-base-api-client';
import { MatriceDto, ResultDto } from '@ideapa/common-dto';

import { ApiClientConfig } from '../api-client-config';

@Injectable()
export class MatriceApiClient extends BaseCRUDApiClient<MatriceDto> {
  baseUrl = this.config.apiEndpoint + '/matrice';

  constructor(http: HttpClient, private config: ApiClientConfig) {
    super(http);
  }

  canImport() {
    return this.http.get<boolean>(`${this.baseUrl}/can-import`);
  }

  canDuplicate() {
    return this.http.get<boolean>(`${this.baseUrl}/can-duplicate`);
  }

  canCopyFromEnte() {
    return this.http.get<boolean>(`${this.baseUrl}/can-copy-from-ente`);
  }

  importExcelFile(file: File, esercizio: number) {
    this._pagedCache.clear();
    const fd = new FormData();
    fd.append('file', file);
    return this.http.post<ResultDto>(
      this.baseUrl + '/import-excel/' + esercizio,
      fd
    );
  }

  duplicate(body: { fromEsercizio: number; toEsercizio: number }) {
    this._pagedCache.clear();
    return this.http.post<ResultDto>(`${this.baseUrl}/duplicate`, body);
  }

  copyFromEnte(body: { fromEnte: number; toEnte: number }) {
    this._pagedCache.clear();
    return this.http.post<ResultDto>(`${this.baseUrl}/copy-from-ente`, body);
  }

  deleteAll() {
    this._pagedCache.clear();
    return this.http.delete(`${this.baseUrl}/delete-all`);
  }
}
